//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbProductTile from '@/elements/product-tile/rb-product-tile.vue'

import RbLoading from '@/elements/loading/rb-loading.vue'
const RbCrossSellingTile = () =>
  import('../minicart/cross-selling-carousel/cross-selling-tile/rb-cross-selling-tile.vue')

import { createNamespacedHelpers, mapGetters } from 'vuex'
import {
  ACTION_FETCH_AND_ADD_CORRELATED_PRODUCT,
  ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY,
  ACTION_SET_RELATED_CATALOG_ENTRIES,
} from '@/scripts/store/actions/pdp'
import { ACTION_ADD_TO_BAG } from '@/scripts/store/actions'
import { mapActions } from 'vuex'
const { mapGetters: mapGettersPdp, mapActions: mapActionsPdp } = createNamespacedHelpers('pdp')

import { MOBILE, TABLET } from '@/scripts/constants/media-query'

import FeaturedProductsCarousel from '@/scripts/libs/featured-products-carousel'

export default {
  name: 'rb-featured-products-carousel',
  components: {
    RbProductTile,
    RbLoading,
    RbCrossSellingTile,
  },
  props: {
    catalogEntries: {
      type: String,
      default: '',
    },
    enableSwiperArrows: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    isInMinicart: {
      type: Boolean,
      default: false,
    },
    hasAddToBag: {
      type: Boolean,
      default: false,
    },
    breakpoints: {
      type: Object,
      default: () => undefined,
    },
    algoliaRecommandation: {
      type: Object,
      default: () => undefined,
    },
  },
  data() {
    return {
      products: [],
      isLoading: true,
      initialized: false,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    ...mapGettersPdp([
      'correlatedProducts',
      'correlatedProductsAvailability',
      'selectedCatEntryId',
      'selectedProduct',
      'cmsDynamicContent',
      'isRoxPanelRendered',
    ]),
    swiperIsVisible() {
      return this.products.length > 0
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    textModuleIsVisible() {
      return this.$slots['title'] || this.$slots['description']
    },
    defaultConfig() {
      if (this.breakpoints) {
        return {
          spaceBetween: 8,
          breakpoints: this.breakpoints,
        }
      }
      return {
        spaceBetween: 8,
        touchStartPreventDefault: false,
        breakpoints: {
          1024: {
            slidesPerView: '3.00075',
          },
          768: {
            slidesPerView: '1.00625',
          },
          375: {
            slidesPerView: '1.05',
          },
          320: {
            slidesPerView: '1.1',
          },
        },
      }
    },
  },
  watch: {
    products(prev, next) {
      if (prev.length !== next.length) {
        this.reInitSwiper()
      }
    },
    cmsDynamicContent(prev, next) {
      if (prev !== next) {
        this.reInitSwiper()
      }
    },
  },
  methods: {
    ...mapActionsPdp({
      fetchAndAddProductAvailability: ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY,
      setRelatedCatalogEntries: ACTION_SET_RELATED_CATALOG_ENTRIES,
      fetchAndAddCorrelatedProduct: ACTION_FETCH_AND_ADD_CORRELATED_PRODUCT,
    }),
    ...mapActions({
      dispatchAddToBag: ACTION_ADD_TO_BAG,
    }),
    async bulkLoadAllCarouselProducts(e) {
      if (
        !this.isRoxPanelRendered &&
        !this.initialized &&
        (e.type === 'enter' || e.type === 'progress')
      ) {
        this.initialized = true
        this.products = await FeaturedProductsCarousel.fetchFeaturedProducts({
          catalogEntries: this.catalogEntries,
          partNumber: this.selectedProduct.partNumber,
          algoliaRecommandation: this.algoliaRecommandation,
          fetchAndAddProductAvailability: this.fetchAndAddProductAvailability,
        })
        this.isLoading = false
      }
    },
    getDataDescription(product) {
      return `${product.modelName}_${product.partNumber}`
    },
    reInitSwiper() {
      if (this.$refs.swiperRef) {
        this.$refs.swiperRef.swiper?.destroy()
        this.$nextTick(() => {
          this.$refs.swiperRef.$options.propsData.config.allowTouchMove = true
          this.$refs.swiperRef._setup()
        })
      }
    },
    addToCart(element) {
      const product = this.products.find((p) => p.catEntryId === element)
      this.dispatchAddToBag({
        catEntry: product.catEntryId,
        isFromMinicart: true,
        MinicartProduct: product,
      })
    },
    createAddToCart(id) {
      let ret = null

      const addToBagLabel = this.translation('common.sidebar_miniwishlist_addto_bag')
      const addToBagLabelInMinicart = this.translation('pdp.sticky_bar.add_to_bag')

      if (this.correlatedProductsAvailability[id]?.isAddToBagEnabled) {
        ret = {
          label: this.isInMinicart ? addToBagLabelInMinicart : addToBagLabel,
          labelAdded: this.translation('pdp.addedToCart'),
          class: 'rb-pdp-related__btn',
          id,
        }
      }

      return ret
    },
  },
}
